"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[9546],{

/***/ 96832:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "static/img/AI_Logo_color.1dc03fee.svg";

/***/ })

}]);